import { defineFcm } from '../shared/factory';

export const FCM_PAYMENTS_SAVE_PAYMENT_CHECKMARK_CONFIG = defineFcm('payments_save_payment_checkmark_config')
	.asBoolean()
	.withDefault(true)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Used on the Promote and Membership Join Page',
		description:
			'This config allows you to control whether the save my payment info checkbox field remains selected or unselected',
	});
